export default {
  TYPE_PROJECT_NEW_COMMENT: 1,
  TYPE_PROJECT_PROMOTED: 2,
  TYPE_PROJECT_RULE_APPROVED: 3,
  TYPE_PROJECT_RULE_REJECTED: 4,
  TYPE_PROJECT_NEW_RULE: 9,
  TYPE_PROJECT_NEW_CATEGORY: 12,
  TYPE_PROJECT_REMOVED_CATEGORY: 13,
  TYPE_PROJECT_CHANGED_CATEGORIES: 14,

  TYPE_DISCUSSION_REPLY: 5,

  TYPE_CATEGORY_NEW_PROJECT: 6,
  TYPE_CATEGORY_ADDED_TO_PROJECT: 15,
  TYPE_CATEGORY_NEW_COMMENT: 7,
  TYPE_CATEGORY_PROJECT_NEW_FILE: 16,
  TYPE_CATEGORY_RULE_APPROVAL_REQUESTED: 8,

  TYPE_INVITED_TO_PROJECT: 11,
  TYPE_DAILY_REPORT: 99,
}